var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "visitorChatList" } },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _vm.chats.length > 0
          ? _c("div", [
              _c(
                "div",
                {
                  staticStyle: { top: "90px", bottom: "30px", width: "100%" },
                  attrs: { id: "visitor-history-list" },
                },
                _vm._l(_vm.chats, function (chat) {
                  return _c(
                    "div",
                    {
                      staticClass: "item",
                      on: {
                        click: function () {
                          return _vm.selectChat(chat)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "margin-right": "28px" } },
                        [
                          _c(
                            "a-avatar",
                            {
                              style: { backgroundColor: "#ffa800" },
                              attrs: {
                                size: 40,
                                src: chat.users.length
                                  ? chat.users[0].gravatar
                                  : undefined,
                                username: chat.users.length
                                  ? chat.users[0].name
                                  : chat.fullname,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "font-size": "14px" } },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        (
                                          (chat.fullname
                                            ? chat.fullname
                                            : "User") || "*"
                                        )
                                          .substr(0, 1)
                                          .toUpperCase()
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "content w-100" }, [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex justify-content-between w-100",
                          },
                          [
                            _c("span", { staticClass: "participant" }, [
                              _vm._v(_vm._s(chat.fullname)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "time" }, [
                              _vm._v(_vm._s(_vm.getDate(chat))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "visitor-messages" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.messageText(
                                  _vm.getLastMessage(chat).description
                                )
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-5" },
                [
                  _c("a-pagination", {
                    attrs: { "show-quick-jumper": "", total: _vm.totalCount },
                    model: {
                      value: _vm.page,
                      callback: function ($$v) {
                        _vm.page = $$v
                      },
                      expression: "page",
                    },
                  }),
                ],
                1
              ),
            ])
          : _c("div", { staticClass: "data-box" }, [
              _c("div", { staticClass: "last-session-info" }, [
                _c(
                  "div",
                  {
                    staticClass: "material-icons",
                    staticStyle: { "font-size": "20px" },
                  },
                  [_vm._v("block")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "last-session-data",
                    staticStyle: { "margin-top": "5px" },
                  },
                  [_vm._v(_vm._s(_vm.$t("visitor.notUserData")))]
                ),
              ]),
            ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }